<template>

  <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div id="errorNotification" class="col-md-12">
          <base-alert v-if="errorMessage != null" type="danger">
            <span class="alert-inner--text"> {{errorMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('error')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
          <base-alert v-if="successMessage != null" type="success">
            <span class="alert-inner--text"> {{successMessage}}</span>
            <button type="button" class="close" aria-label="Close" @click="removeMessage('success')">
              <span aria-hidden="true">&times;</span>
            </button>
          </base-alert>
        </div>
        <div class="col-md-3">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{_.startCase(currentProfile)}}
          </h3>
        </div>
        <div class="col-md-9 text-right">
           <base-dropdown class="nav-link pr-0 float-right" position="right">
            <div class="media align-items-center" slot="title">
              <i class="fa fa-ellipsis-v float-right ml-2 btn-sm"></i>
            </div>
            <template>
              <div class="dropdown-header noti-title">
                <h6 class="text-overflow m-0">ACTIONS</h6>
              </div>
              <div v-if="accessRights.includes('E')" class="dropdown-item"
                @click.prevent="download()">
                <i class="fa fa-download"></i>
                <span>Export</span>
              </div>
            </template>
          </base-dropdown>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <vuetable v-if="currentProfile == 'pos_reservations'" ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="reservation_fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data" no-data-template="Empty"
        @vuetable:load-error="onLoadError" 
        @vuetable:pagination-data="onPaginationData">

        <template slot="actions" slot-scope="props">
          <center>
            <button class="btn btn-success btn-sm" @click.prevent="showDetails(props.rowData.id)">View Details</button>&nbsp;&nbsp;
          </center>
        </template>

      </vuetable>

      <vuetable v-else ref="vuetable" :api-url="apiURL" :http-options="httpOptions" :fields="fields" :sort-order="sortOrder"
        :show-sort-icons="true" :per-page="10" :css="css.table" pagination-path="" data-path="data" no-data-template="Empty"
        @vuetable:load-error="onLoadError" 
        @vuetable:pagination-data="onPaginationData">

        <template slot="actions" slot-scope="props">
          <center>
            <button class="btn btn-success btn-sm" @click.prevent="showDetails(props.rowData.id)">View Details</button>&nbsp;&nbsp;
          </center>
        </template>

      </vuetable>
    </div>

    <div class="card-footer d-flex justify-content-end" :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="pagination ui basic segment grid">
        <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage" :css="css.pagination">
        </vuetable-pagination>
      </div>
    </div>

  </div>
</template>

<script>

  import axios from "axios";
  import {
    mapState
  } from 'vuex'

  import Vuetable from "vuetable-2/src/components/Vuetable";
  import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';

  var component_x;

  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {
      Vuetable,
      VuetablePagination
    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType'])
    },
    data() {
      return {
        filterStatus: "",
        profileAction: "",
        errorMessage: null,
        successMessage: null,
        componentKey: 0,
        visible: false,
        availableFields: [],
        apiURL: "",
        fields: [ {name: "terminal_name", title: "Terminal"}, 
                  {name : "site_name", title: "Site"},
                  {name : "trans_id", title: "Trans ID"},
                  {name : "invoice_no", title: "OR/SI No"},
                  {name : "order_no", title: "Order No"},
                  {name : "document_no",  title: "Doc No"},
                  {name : "cashier_name",title: "Cashier"},
                  {name : "business_date_formatted", title: "Business Date"},
                  {name : "processed_status", title: "Status"},
                  '__slot:actions'
                ],
        reservation_fields: [ {name: "terminal_name", title: "Terminal"}, 
          {name : "site_name", title: "Site"},
          {name : "trans_id", title: "Trans ID"},
          {name : "so_doc", title: "Reservation No"},
          {name : "cashier_name",title: "Cashier"},
          {name : "business_date_formatted", title: "Business Date"},
          {name : "created_at_formatted", title: "Created At"},
          {name : "processed_status", title: "Status"},
          '__slot:actions'
        ],
        sortOrder: [{
          field: "business_date",
          direction: "desc"
        }],
        httpOptions: {
          headers: {
            Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-Web"
          }
        },
        css: {
          table: {
            tableClass: 'table table-sm table-striped table-bordered table-hovered',
            loadingClass: 'loading'
          },
          pagination: {
            infoClass: 'pull-right',
            wrapperClass: 'vuetable-pagination pull-right',
            activeClass: 'btn-primary btn-sm',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: '',
              prev: '',
              next: '',
              last: '',
            },
          }
        },
        export_fields: ["terminal", "site", "trans_id", "invoice_no", "order_no", "document_no", "cashier_name", "business_date", "status"],
        accessRights: [],
      }
    },
    watch: {
      currentApiURL: function () {
        this.$refs.vuetable.resetData()
        this.apiURL = this.currentApiURL
      },
      parameters: function () {
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters
        this.$refs.vuetable.selectedTo = []		
        this.checkedItems = []
      }
    },
    methods: {
      showDetails(id){
        this.$router.push({
            name: 'pos_document_form',
            params: {
                posDocumentId: id,
                message: "Hello"
            }
        })
      },
      refreshPage() {
        this.onClose()
        this.$refs.vuetable.refresh()
        this.successMessage = "Successful Operation"
        this.errorMessage = null
      },
      removeMessage(type) {
        if (type == 'error')
          this.errorMessage = null
        else
          this.successMessage = null
      },
      async onPaginationData(paginationData) {
        // await axios({
        //     method: 'PUT',
        //     url: this.endPoint.split("/api")[0] + "/api/v2/backend_sessions/" + secureStorage.getItem("sessionId") + "/update_timestamp",
        //     headers: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"},
        // })
        this.$refs.pagination.setPaginationData(paginationData);
      },
      async onLoadError(error) {
        // request for new token or reauthenticate
        if (error.response.status == 401) {
          var auth_response = await HTTPRequest.authenticate(component_x.endPoint)
          if (auth_response["status"] == "Ok") {
            this.$router.go();
          } else {
            alert("Cannot get access token. Please login again.")
            this.$router.push("/")
          }
        } else {
          if(error.response.data.error == "Session expired"){
              alert("Session is already expired. Please login again.")
              document.getElementById("logoutButton").click()
          }
        }
      },
      onChangePage(page) {
        this.$refs.vuetable.changePage(page);
      },
      download() {
        var payload = {};
        var additional_parameters = "";
        var baseUrl = this.endPoint + "pos_documents" + "/download?file_type=csv";
        if (this.filterStatus == "0") {
          // All
          payload["type"] = "all";
        } else if (this.filterStatus == "1") {
          // Current Page
          payload["type"] = "current_page";
          additional_parameters = this.parameters;
          additional_parameters =
            additional_parameters +
            "&page=" +
            this.$refs.vuetable.currentPage +
            "&per_page=" +
            this.$refs.vuetable.perPage;
        } else if (this.filterStatus == "2") {
          // Selected
          payload["type"] = "selected";
          payload["ids"] = this.checkedItems;
        } else {
          // Filtered
          payload["type"] = "filtered";
          additional_parameters = this.parameters;
        }

        var exportFields = this.fields;
        var cbIndex = this.fields.indexOf("__checkbox");
        if (cbIndex > -1) exportFields.splice(cbIndex, 1);
        var actionIndex = this.fields.indexOf("__slot:actions");
        if (actionIndex > -1) exportFields.splice(actionIndex, 1);

        payload["fields"] = this.export_fields;
        additional_parameters = additional_parameters.replace("?", "&");

        axios({
          url: baseUrl + additional_parameters,
          method: "POST",
          responseType: "blob", // important
          headers: {
            Authorization: "Bearer " + secureStorage.getItem("accessToken"),
            "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File"
          },
          data: payload,
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "POS_Documents_List.csv");
          document.body.appendChild(link);
          link.click();
          this.filterStatus = null;
          this.successMessage = "Download successful";
          this.onClose();
        });
      },
    },
    mounted: function () {
      component_x = this;
      this.apiURL = this.currentApiURL + this.parameters
      this.accessRights = this.$attrs.accessRights;
    }
  }
</script>

<style>
</style>